module.exports = "<app-payments></app-payments>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-provider/payments-prov/payments-prov.component.html
// module id = 2406
// module chunks = 66